/* @ngInject */
function campaignService ($translate, $q, CONSTANTS, ConnectorWebService, Utils, AssetService, ArtCollectionsService, UdsModalService, ConfirmationModalService) {
  const getBindCampaignDialogController = () => $q.when(import('../dialogs/bind-campaign/bind-campaign-dialog.controller'))

  const service = {
    getAllCampaigns,
    getAvailableCampaigns,
    createCampaign,
    getCampaign,
    updateCampaign,
    archiveCampaign,
    unarchiveCampaign,
    getCampaignTasks,
    getCampaignPosts,
    getCampaignChecklists,
    getCampaignCollections,
    getCampaignTemplates,
    addAttachmentsToCampaign,
    getCampaignAttachments,
    removeAttachmentFromCampaign,
    updateCampaignSegmentation,
    getArchiveHtmlDescription,
    openUnbindCampaignDialog,
    shouldShowCampaignWarning,
    shouldShowCampaignWarningMultipleData,
    showDataCampaignWarning,
    showCollectionCampaignWarning,
    getDocuments,
    createDocument,
    deleteDocument,
    getCampaignsFinishingSoon
  }
  return service

  function getAllCampaigns (params = {}) {
    const {
      top,
      skip,
      search,
      campaignIds,
      isAvailable = false,
      isAnalytics = false,
      isArchived = false,
      campaignStatus,
      campaignStatusRest,
      usersGroup,
      startDateStart,
      startDateEnd,
      deliveryDateStart,
      deliveryDateEnd,
      $order
    } = params

    let url = CONSTANTS.URL_CAMPAIGNS

    if (isAvailable) {
      url = Utils.fnAddQueryToUrl(url, { isAvailable })
    }

    if (isAnalytics) {
      url = Utils.fnAddQueryToUrl(url, { isAnalytics })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (campaignIds) {
      const campaignIdsArray = Array.isArray(campaignIds) ? campaignIds : [campaignIds]
      url = Utils.fnAddQueryToUrl(url, { campaignIds: campaignIdsArray })
    }

    url = Utils.fnAddQueryToUrl(url, { isArchived })

    if ((campaignStatus && campaignStatus.length) || (campaignStatusRest && campaignStatusRest.length)) {
      url = Utils.fnAddQueryToUrl(url, { campaignStatus: [...campaignStatus, ...campaignStatusRest] })
    }

    if (usersGroup) {
      url = Utils.fnAddQueryToUrl(url, { usersGroup })
    }

    if (startDateStart) {
      url = Utils.fnAddQueryToUrl(url, { startDateStart })
    }

    if (startDateEnd) {
      url = Utils.fnAddQueryToUrl(url, { startDateEnd })
    }

    if (deliveryDateStart) {
      url = Utils.fnAddQueryToUrl(url, { deliveryDateStart })
    }

    if (deliveryDateEnd) {
      url = Utils.fnAddQueryToUrl(url, { deliveryDateEnd })
    }

    if (top) {
      url = Utils.fnAddQueryToUrl(url, { $top: top })
    }

    if (skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip: skip })
    }

    if ($order) {
      url = Utils.fnAddQueryToUrl(url, { $order })
    }

    return ConnectorWebService.get(url)
  }

  function getAvailableCampaigns () {
    let url = CONSTANTS.URL_CAMPAIGNS

    url = Utils.fnAddQueryToUrl(url, { isAvailable: true })

    return ConnectorWebService.get(url)
  }

  function getCampaign (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID, [campaignId])
    return ConnectorWebService.get(url)
  }

  function createCampaign (payload = {}) {
    const url = CONSTANTS.URL_CAMPAIGNS

    return ConnectorWebService.post(url, payload)
  }

  function updateCampaign (campaignId, payload = {}) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID, [campaignId])
    return ConnectorWebService.put(url, payload)
  }

  function archiveCampaign (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ARCHIVE, [campaignId])
    return ConnectorWebService.put(url)
  }

  function unarchiveCampaign (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_UNARCHIVE, [campaignId])
    return ConnectorWebService.put(url)
  }

  function addAttachmentsToCampaign (params) {
    const { assets, campaignId } = params

    if (!campaignId || !assets.length) {
      return
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ATTACHMENTS, [campaignId])

    const payload = {
      assets
    }

    return ConnectorWebService.post(url, payload)
  }

  function removeAttachmentFromCampaign (params) {
    const { assetId, campaignId } = params

    if (!campaignId || !assetId) {
      return
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ATTACHMENTS_ASSET_ID_UNBIND, [campaignId, assetId])

    return ConnectorWebService.put(url)
  }

  function getCampaignAttachments (params) {
    const { campaignId } = params

    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ATTACHMENTS, [campaignId])

    return ConnectorWebService.get(url).then(response => {
      if (!response.count) {
        return response
      }

      return {
        count: response.count,
        rows: response.rows.map(row => {
          row.src = AssetService.getAssetSrcAttributes(row)

          return row
        })
      }
    })
  }

  function getCampaignCollections (params) {
    const { campaignId, idArtCollection } = params

    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_COLLECTIONS, [campaignId])

    if (idArtCollection) {
      url = Utils.fnAddQueryToUrl(url, { idArtCollection })
    }

    return ConnectorWebService.get(url)
  }

  function getCampaignTemplates (params) {
    const { campaignId, idArtCollection } = params

    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_TEMPLATES, [campaignId])

    if (idArtCollection) {
      url = Utils.fnAddQueryToUrl(url, { idArtCollection })
    }

    return ConnectorWebService.get(url)
  }

  function getCampaignTasks (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_TASKS, [campaignId])
    return ConnectorWebService.get(url)
  }

  function getCampaignPosts (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_POSTS, [campaignId])
    return ConnectorWebService.get(url)
  }

  function getCampaignChecklists (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_BRIEFINGS, [campaignId])
    return ConnectorWebService.get(url)
  }

  function updateCampaignSegmentation (campaignId, segmentationData) {
    if (!campaignId) throw new Error('campaignId cannot be null')

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_SEGMENTATION, [campaignId])
    return ConnectorWebService.put(url, segmentationData)
  }

  function getDocuments ({ campaignId }) {
    if (!campaignId) throw new Error('campaignId cannot be null')
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_DOCUMENTS, [campaignId])
    return ConnectorWebService.get(url)
  }

  function createDocument ({ campaignId, template }) {
    if (!campaignId) throw new Error('campaignId cannot be null')
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_DOCUMENTS, [campaignId])
    return ConnectorWebService.post(url, { template })
  }

  function deleteDocument ({ campaignId, documentId }) {
    if (!campaignId) throw new Error('campaignId cannot be null')
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_DOCUMENTS_DELETE_ID, [campaignId, documentId])
    return ConnectorWebService.fnDelete(url)
  }

  function getArchiveHtmlDescription (campaignName, type = 'archive') {
    const firstLine = type === 'delete' ? $translate.instant('archiveAssetWithCampaign.firstLineDelete', { campaignName }) : $translate.instant('archiveAssetWithCampaign.firstLineArchive', { campaignName })
    const firstItem = $translate.instant('archiveAssetWithCampaign.firstItem')
    const secondItem = $translate.instant('archiveAssetWithCampaign.secondItem')
    const lastLine = $translate.instant('archiveAssetWithCampaign.lastLine')

    return `
      <uds-body size="sm" font-weight="regular">
        ${firstLine}
        <ul>
          <li>${firstItem}</li>
          <li>${secondItem}</li>
        </ul>
        ${lastLine}
      </uds-body>
    `
  }

  function openUnbindCampaignDialog (data, currentModule, onClose) {
    const isArt = 'isTemplate' in data
    const artCollectionId = isArt ? data.artCollectionId : data.parentId
    const hasFiles = !isArt ? data.countFiles > 0 : false

    ArtCollectionsService.isArtCollectionInsideCampaign(artCollectionId).then(response => {
      if (response.isInsideCampaign) {
        ConfirmationModalService.createModal({
          title: $translate.instant('warning'),
          description: $translate.instant('campaignErrors.unbindCampaignInsideCampaignFolder'),
          buttonConfirmText: $translate.instant('ok'),
          hideCancelButton: true
        })
      } else {
        getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
          const bindCampaignDialog = UdsModalService.createModal({
            controller: BindCampaignDialogController,
            modalName: 'bindCampaignDialog',
            data: {
              currentModule,
              assetId: data.id,
              campaignId: data.campaignId,
              campaignName: data.campaignName,
              showUnbindMaterials: hasFiles
            },
            onClose
          })

          bindCampaignDialog.open()
        })
      }
    })
  }

  function shouldShowCampaignWarning (data, selectedOption, isUnarchiving = false) {
    const dataHasCampaign = data.campaignId && data.isActiveInCampaign !== false
    const collectionHasCampaign = selectedOption.campaignId && (selectedOption.isActiveInCampaign || selectedOption.isActiveInCampaign === null)
    const dataHasSameCampaign = data.campaignId === selectedOption.campaignId
    const isSelectedOptionSection = selectedOption.parentId === null
    if (isSelectedOptionSection) {
      return {
        showDataWarning: false,
        showCollectionWarning: false,
        campaignName: null
      }
    }

    const response = {
      showDataWarning: dataHasCampaign && collectionHasCampaign && !dataHasSameCampaign && !isUnarchiving,
      showCollectionWarning: collectionHasCampaign && (!dataHasCampaign || (dataHasCampaign && !dataHasSameCampaign)),
      campaignName: data.campaignName
    }

    return response
  }

  function shouldShowCampaignWarningMultipleData (data, selectedOption) {
    const result = data.some(item => {
      const { showDataWarning, showCollectionWarning } = service.shouldShowCampaignWarning(item, selectedOption)
      return showDataWarning || showCollectionWarning
    })
    const campaignName = result ? data.find(item => item.campaignId)?.campaignName : null
    return { showCollectionWarning: result, showDataWarning: result, campaignName }
  }

  function showDataCampaignWarning (campaignName) {
    ConfirmationModalService.createModal({
      title: $translate.instant('warning'),
      description: $translate.instant('campaignErrors.cannotMoveDataLinkedToCampaign', { campaignName }),
      buttonConfirmText: $translate.instant('ok'),
      hideCancelButton: true
    })
  }

  function showCollectionCampaignWarning () {
    ConfirmationModalService.createModal({
      title: $translate.instant('warning'),
      description: $translate.instant('campaignErrors.cannotMoveToFolderWithCampaigns'),
      buttonConfirmText: $translate.instant('ok'),
      hideCancelButton: true
    })
  }

  function getCampaignsFinishingSoon () {
    const url = CONSTANTS.URL_CAMPAIGNS_FINISHING_SOON
    return ConnectorWebService.get(url)
  }
}

export { campaignService }
